import styled from 'styled-components';

const shouldForwardProp = prop => !['title', 'options', 'checked', 'isDisabled'].includes(prop);

const checkedStyle = (checked, isDisabled) => {
  if (checked) {
    if (isDisabled) {
      return `
        border: 1px solid var(--Support-Purple);
        background: var(--GrayScale-0);
      `;
    } else {
      return `
        border: 1px solid var(--Support-Purple);
        background: var(--Primary-50);
      `;
    }
  } else {
    return `
        border: 1px solid var(--GrayScale-0);
        background: var(--GrayScale-0);
    `;
  }
};

export const RadioOptionGroupStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  padding: 16px;
  cursor: pointer;
  border-radius: 10px;

  .radioOptionGroup {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    margin-top: 0;
    display: flex;
    padding-left: 8px;
    flex-direction: column;
    gap: 16px;
    &.open {
      max-height: 500px;
      opacity: 1;
      margin-top: 16px;
    }

    &.close {
      max-height: 0;
      opacity: 0;
      margin-top: 0;
    }
  }

  ${props => checkedStyle(props.checked, props.isDisabled)}
`;
